import {fetchWeChatJSSDKConf} from '@api'
import {useApplicationStore} from '@stores/application.store'

const DOMAIN = import.meta.env.VITE_DOMAIN

export const afterEach = async (to) => {
  const applicationStore = useApplicationStore()

  // WeChat JSSDK:
  // - before 2020.12.15
  //   - iOS WeChat: use "landing page URL" to request verification
  //   (landing page URL is accessed through store.state.WechatJSSDK.entryUrl)
  //   - iOS WeCom: use "current page URL" to request verification
  //   - Android (no distinction between "WeChat" or "WeCom"),
  //     use "current page URL" to request verification
  // - after 2020.12.15
  // - all adjusted to use "current page URL" to request verification
  // - 2023.08.08:
  // - The "Store(vuex)" is no longer considered necessary, and the
  //   ientire WeChat-JSSDK-
  //   validation process happens in the `afterEach` guard.
  if (applicationStore.wechat || applicationStore.wework){
    const CURRENT_URL = DOMAIN + to.fullPath
    const defaultConfiguration = await fetchWeChatJSSDKConf({
      url: CURRENT_URL,
    })

    wx && wx.config({
      debug: false,
      beta: true,
      appId: defaultConfiguration.appId,
      timestamp: defaultConfiguration.timestamp,
      nonceStr: defaultConfiguration.nonceStr,
      signature: defaultConfiguration.signature,
      jsApiList:  [
        'previewImage',
        'updateAppMessageShareData',
        'updateTimelineShareData',
      ],
    })

    // wx.error
    // wx && wx.error(function (res){
    // alert(JSON.stringify(res))
    // })
  }

  if (window._hmt) {
    window._hmt.push(['_trackPageview', to.fullPath])
  }

  if (to && to.meta && to.meta.title) {
    document.title = to.meta.title
  }
}

